import { Campaigns } from 'containers/Campaigns'

export default Campaigns
